import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseCombobox } from '../../controls/BaseCombobox';
import { StepPage } from '../../controls/StepPage';
import orderService from '../OrderService';

export class EarmoldStep2Page extends StepPage {

    constructor(props) {
        super(props);
        let options = orderService.GetCurrentProductEarmoldOptionSettings();
        let selectedOption = this.props.model.bteOrRic ?? options.find(x => x.disabled === false);
        this.state = { options: options, selectedOption: selectedOption };
        this.handleValueSeleted = this.handleValueSeleted.bind(this);
        if (!this.props.model.bteOrRic) {
            this.props.model.bteOrRic = "BTE"
        }
    }       

    handleValueSeleted(e) {
        //TODO set selection BTE or RIC to model
        let target = e.target;
        let value = target.value;
        
        this.props.model.bteOrRic = value;
        this.props.model.eardrumRic = "";
        this.props.model.eardrumBte = "";
        this.setState({ selectedOption: value });
    }

    validate() {
        ////TODO
        return { state: true, msg: "todo check page2" };
    }

    render() {
        let model = this.props.model;
        if (!model) {
            return null;
        }
        if (this.state.options.length <= 0) {
            return null;
        }

        let options = this.state.options;
        let selectedOption = this.state.selectedOption;
                
        return <div className="flex gap-6">
            <div className="w-1/3">
                <label><FormattedMessage id="BTEORRIC1" /></label>
                <BaseCombobox classnames="mt-1" onChangeCapture={this.handleValueSeleted} value={selectedOption}>
                    {options.map(o =>
                        !o.disabled &&<option disabled={o.disabled} className={o.disabled ? 'text-gray-300' : ''} key={o.value} value={o.value}  >{o.label}</option>
                    )}
                </BaseCombobox>
            </div>
        </div>
    }
}
